"use strict";

(() => {
  const toTop = document.querySelector("[data-to-top]");

  if (!toTop) {
    return;
  }

  let ticking = false;

  const sync = () => {
    const scrolled = window.scrollY || document.documentElement.scrollTop;
    toTop.classList.toggle("js-show", scrolled > window.innerHeight);
  };

  const onScroll = () => {
    if (ticking) {
      return;
    }

    ticking = true;

    window.requestAnimationFrame(() => {
      sync();
      ticking = false;
    });
  };

  toTop.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  sync();
})();
